import { toDesignButton } from '@/lib/transformers'
import { Typo3SectionSpotSanityEventList } from '@/types/typo3'
import { SectionUpcomingEventsProps } from '@/ui/Sections/SectionUpcomingEvents/type'

const toSectionUpcomingEvents = (section: Typo3SectionSpotSanityEventList) =>
  ({
    section: section,
    overline: section?.content?.overline,
    title: section?.content?.title,
    titleLayout: section.content?.titleLayout,
    buttons: section.content?.buttons?.map((btn) => toDesignButton(btn)),
    items: section.content?.items?.map((item) => ({
      id: item.uid || '',
      title: item.title,
      subTitle: ``,
      date: item?.textDates?.[0]?.interval,
      cardDate: item?.textDates?.[0]?.firstActive,
      text: item.summary,
      location: item.infoLocation,
      link: {
        href: item?.slug,
        title: item?.title
      },
      isTopEvent: item.isTopEvent,
      image: item?.images ? item?.images[0] : undefined,
      openings: item.textDates,
      coordinates: item.coordinates
    }))
  }) as SectionUpcomingEventsProps

export default toSectionUpcomingEvents
